<template lang='pug'>
  i.svg-icon.svg-icon-android
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )

      path(d="M26.43,36.25c16.13,0,32.17,0,48.33,0c0.02,0.35,0.06,0.67,0.06,0.99c0,11.76-0.03,23.52,0.03,35.28 c0.01,2.56-1.59,4.34-4.2,4.17c-1.89-0.12-3.79-0.02-5.83-0.02c0,0.44,0,0.79,0,1.15c0,3.81,0.02,7.62-0.01,11.42 c-0.02,2.39-1.57,4.34-3.82,4.93c-2.28,0.61-4.71-0.33-5.84-2.41c-0.43-0.8-0.67-1.8-0.69-2.71c-0.07-3.74-0.03-7.49-0.03-11.24 c0-0.33,0-0.67,0-1.07c-2.53,0-5.01,0-7.6,0c-0.02,0.33-0.05,0.68-0.05,1.04c-0.01,3.87,0.03,7.74-0.03,11.61 c-0.03,2.16-1.44,4-3.41,4.69c-2.01,0.7-4.22,0.15-5.63-1.44c-0.89-1-1.32-2.19-1.32-3.54c0-3.78,0-7.55,0-11.33 c0-0.33,0-0.66,0-1.1c-2.24,0-4.38,0.02-6.52-0.01c-1.6-0.02-2.92-1.03-3.33-2.54c-0.1-0.38-0.13-0.79-0.13-1.18 c-0.01-12.01-0.01-24.01,0-36.02C26.39,36.74,26.41,36.56,26.43,36.25z")

      path(d="M26.11,33.81c1.17-8.3,5.36-14.52,12.5-18.86c-1.08-2.11-2.15-4.2-3.23-6.3c-0.07-0.14-0.15-0.27-0.22-0.4 c-0.29-0.55-0.5-1.13,0.22-1.49c0.7-0.35,0.99,0.2,1.25,0.71c1.08,2.09,2.16,4.19,3.25,6.29c0.07,0.13,0.15,0.26,0.26,0.42 c6.87-3.02,13.73-3.07,20.72-0.08c0.51-0.88,1.02-1.77,1.54-2.67c0.78-1.35,1.57-2.71,2.35-4.06c0.3-0.52,0.64-1.09,1.35-0.65 c0.68,0.42,0.38,0.99,0.07,1.52c-1.26,2.17-2.52,4.35-3.81,6.59c7.26,4.27,11.5,10.56,12.72,18.97 C58.77,33.81,42.52,33.81,26.11,33.81z M41.55,23.14c-0.02-1.08-0.93-1.98-2.01-1.97c-1.11,0-2.04,0.96-2.02,2.07 c0.03,1.08,0.94,1.97,2.02,1.97C40.68,25.2,41.57,24.29,41.55,23.14z M63.67,23.21c0.01-1.1-0.85-2-1.94-2.04 c-1.1-0.03-2.08,0.9-2.09,2c-0.01,1.12,0.93,2.04,2.05,2.03C62.78,25.19,63.66,24.31,63.67,23.21z")

      path(d="M87.44,51.69c0,3.81,0.02,7.62-0.01,11.43c-0.02,2.35-1.62,4.44-3.77,5.01c-2.32,0.62-4.75-0.27-5.86-2.35 c-0.47-0.88-0.75-1.97-0.76-2.97c-0.06-7.43-0.05-14.87-0.02-22.3c0.01-3.16,2.28-5.39,5.32-5.36c2.93,0.03,5.1,2.36,5.11,5.49 C87.44,44.32,87.44,48.01,87.44,51.69z")

      path(d="M24.14,51.78c0,3.72,0.02,7.43-0.01,11.15c-0.02,2.81-1.67,4.79-4.3,5.28c-3.11,0.58-6.07-1.73-6.09-4.93 c-0.06-7.71-0.05-15.42,0-23.12c0.02-2.76,2.33-4.97,5.02-5c2.91-0.04,5.25,1.97,5.33,4.84c0.11,3.93,0.03,7.86,0.03,11.79 C24.12,51.78,24.13,51.78,24.14,51.78z")

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
